import $ from 'jquery';
import Flickity from 'flickity';

// import debounce from '@core/plugins/lib/fn.js';
import debug from 'debug';
import plugin from '@core/plugins/lib';
import { PLUGIN_NAME } from './index';

const log = debug('components/blocks/profile-carousel:flickity');

class ProfileCarousel {
	constructor(element, options) {
		log('construct', element, options);

		this.options = options;
		this.element = element;
		this.$element = $(element);

		this.init();
		this.watch();
	}

	init() {
		Flickity.prototype._createResizeClass = function() {
			this.element.classList.add('flickity-resize');
		};
		Flickity.createMethods.push('_createResizeClass');
		const resize = Flickity.prototype.resize;

		Flickity.prototype.resize = function() {
			this.element.classList.remove('flickity-resize');
			resize.call(this);
			this.element.classList.add('flickity-resize');
		};

		this.carousel = new Flickity(this.element, {
			arrowShape: this.options.arrowShape,
			percentPosition: false,
			watchCSS: true,
			groupCells: true,
			initialIndex: 0,
			on: {
				ready: this.onReady.bind(this)
			}
		});
	}

	watch(){
		this.carousel.on('change', this.onChange.bind(this));
	}

	onReady(){
		log('Flickity ready');
		this.setInstance();
		this.updateTabindex();
	}

	setInstance () {
		this.carousel = Flickity.data(this.element);
		return this.carousel;
	}

	onChange(index){
		log('onchange index', index);
		this.updateTabindex();
	}

	updateTabindex(){
		log('updateTabindex');

		const cells = this.carousel.getCellElements();
		const selectedCells = this.carousel.selectedElements;
		log('selectedElements', selectedCells);

		const unselectedCells = $(cells).not(selectedCells);
		log('unselectedCells', unselectedCells);

		this.disableLinks(unselectedCells);
		this.enableLinks(selectedCells);

	}

	disableLinks(parentElements){
		$(parentElements).find('a').attr('tabindex','-1');
	}

	enableLinks(parentElements){
		$(parentElements).find('a').removeAttr('tabindex');
	}
}

ProfileCarousel.DEFAULTS = {};

export default ProfileCarousel;



// WEBPACK FOOTER //
// ./project/client/src/site__ale001/components/blocks/people-featured-layout/profile-carousel.js